import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { COLOR_SCHEME_CLASSNAMES } from 'stores/global/AccessibilityParamsStore/ColorSchemeStore/constants';
import { accessibilityParamsStore } from 'stores/root';

const GlobalAccessibilityProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isOpen: isAccessibilityMode } = accessibilityParamsStore;
  const { fontSizeMultiplier } = accessibilityParamsStore.fontSizeStore;
  const { lineHeightMultiplier, isDefaultLineHeight } = accessibilityParamsStore.lineHeightStore;
  const { colorScheme } = accessibilityParamsStore.colorSchemeStore;

  React.useEffect(() => {
    document.documentElement.style.setProperty('--global-font-size-multiplier', String(fontSizeMultiplier));
    document.documentElement.style.setProperty(
      '--global-line-height-multiplier',
      isDefaultLineHeight ? 'normal' : String(lineHeightMultiplier)
    );
  }, [fontSizeMultiplier, lineHeightMultiplier, isDefaultLineHeight]);

  React.useEffect(() => {
    const root = document.documentElement;

    Object.values(COLOR_SCHEME_CLASSNAMES).forEach((className) => {
      root.classList.remove(className);
    });

    if (isAccessibilityMode) {
      root.classList.add(COLOR_SCHEME_CLASSNAMES[colorScheme]);
    }
  }, [isAccessibilityMode, colorScheme]);

  return <>{children}</>;
};

export default observer(GlobalAccessibilityProvider);
